import { render, staticRenderFns } from "./RelativeRelationTypeTable.vue?vue&type=template&id=6705195f&"
import script from "./RelativeRelationTypeTable.vue?vue&type=script&lang=js&"
export * from "./RelativeRelationTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports